/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function HandsClapping(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path
          d="M111.99332,114.41921l-26-45.03332a20,20,0,0,1,34.641-20l40,69.282"
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
        <Path
          d="M85.35231,148.27562l-42-72.74613a20,20,0,1,1,34.641-20l42,72.74613"
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
        <Path
          d="M168.63434,132.52433l-18-31.17691a20,20,0,1,1,34.641-20l20,34.641a80,80,0,1,1-138.56406,80l-42-72.74613a20,20,0,0,1,34.641-20l22,38.10512"
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
      </G>
      <G>
        <Line
          x1={156}
          y1={12}
          x2={156}
          y2={28}
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
        <Line
          x1={204}
          y1={24.86156}
          x2={196}
          y2={38.71797}
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
        <Line
          x1={239.13844}
          y1={60}
          x2={225.28203}
          y2={68}
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
      </G>
    </Svg>
  );
}

export default HandsClapping;
